import { useContext } from 'react';
import { GeneralContext } from '../context';

export function useGeneral() {
    const context = useContext(GeneralContext);
    return { ...context };
}
